import * as xlsx from 'xlsx/xlsx.mjs'

const exportExcel = (json, name, format) => {
  const data = format ? [] : json
  json.forEach((item) => {
    const row = {}
    Object.keys(format).forEach((key) => {
      row[format[key]] = item[key]
    })
    data.push(row)
  })
  const ws = xlsx.utils.json_to_sheet(data)
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] }

  const buffer = xlsx.write(wb, { bookType: 'xlsx', type: 'array' })
  const EXCEL_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  const EXCEL_EXTENSION = '.xlsx'
  const blob = new Blob([buffer], {
    type: EXCEL_TYPE,
  })

  const link = document.createElement('a')
  const url = window.URL.createObjectURL(blob)
  link.href = url
  link.download = `${name}${EXCEL_EXTENSION}`
  link.click()
}
const exportGroupExcel = (json, name, format) => {
  const wb = { Sheets: {}, SheetNames: [] }
  Object.keys(json).forEach((key) => {
    const list = []
    json[key].forEach((item) => {
      const row = {}
      Object.keys(format).forEach((keyItem) => {
        row[format[keyItem]] = item[keyItem]
      })
      list.push(row)
    })

    const ws = xlsx.utils.json_to_sheet(list)
    wb.Sheets[key] = ws
    wb.SheetNames.push(key)
  })

  const buffer = xlsx.write(wb, { bookType: 'xlsx', type: 'array' })
  const EXCEL_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  const EXCEL_EXTENSION = '.xlsx'
  const blob = new Blob([buffer], {
    type: EXCEL_TYPE,
  })

  const link = document.createElement('a')
  const url = window.URL.createObjectURL(blob)
  link.href = url
  link.download = `${name}${EXCEL_EXTENSION}`
  link.click()
}

export { exportExcel, exportGroupExcel }
